<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">
      <div class="login100-pic js-tilt" data-tilt>
        <img src="assets/img/left-bg.jpg" height="100%" width="100%"/>
      </div>
      <form class="login100-form validate-form" [formGroup]="loginForm" (ngSubmit)="onLogin()">
					<span class="login100-form-title">
					<img src="assets/img/new_dasboard_imges/loginbluvbay.png" height="57" width="165"/></span>
        <p class="signin">Sign In</p>
        <div class="wrap-input100">
          <input class="input100" formControlName="userName" [(ngModel)]="sessionModel.userName" type="text"
                 name="email" autocomplete="off" placeholder="User name"
                 [ngClass]="{ 'is-invalid': submitted && f.userName.errors }">
          <span class="symbol-input100">
							<i class="fa fa-envelope" aria-hidden="true"></i>
						</span>
          <div *ngIf="submitted && f.userName.errors" class="invalid-feedback">
            <div *ngIf="f.userName.errors.required" class="alert-color">Username is required</div>
          </div>
        </div>
        <div class="wrap-input100" data-validate="Password is required">
          <input class="input100" type="password" formControlName="password" [(ngModel)]="sessionModel.password"
                 name="pass"
                 placeholder="Password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required" class="alert-color">Password is required</div>
          </div>
          <span class="symbol-input100">
							<i class="fa fa-lock" aria-hidden="true"></i>
						</span>
        </div>
        <div class="wrap-input100 validate-input">
          <span class="reset" routerLink="/forgotpasswordstep1">Forgot Password</span>
          <!-- <span class="reset" routerLink="/resetpasswordstep1">Reset Password</span> -->
        </div>
        <div class="container-login100-form-btn">
          <span class="lgnbtn"><button type="submit" class="btn">
            <span><i class="fa fa-lock loginicon" aria-hidden="true"></i></span>Login</button></span>
        </div>
        <div class="footer" style="margin-top: 35%;">
          <a href="https://www.aqucloud.com:83/BluBay/termsofuse.html" target="_blank">T & C</a> |
          <a href="https://www.aqucloud.com:83/BluBay/privacy_policy.html" target="_blank">Privacy Policy</a> |
          <a href="https://www.aqucloud.com:83/BluBay/BB_Mobile_Web_Account_closure.html" target="_blank">Account Closure info</a>
        </div>
      </form>
    </div>
  </div>
</div>
